export default `vec3 Q;
    float i,j,d=1.,a;
    d=.6; a=1.;
    for(j=0.;j++<9.;)
      Q=(p+fract(sin(j*vec3(7.0,8.0,9.0))*1e3)*9.)*a,
      Q+=sin(Q*.5),
      Q=sin(Q),
      d+=Q.x*Q.y*Q.z/a,
      a*=2.;
    return d*.3;
  }`